module.exports = __webpack_public_path__ + "static/media/047-dominican-republic.350f1c51.svg";